<template>
  <div>

    <form-accordion :title="pageTitle" :isTitleUpperCase="false">
      <b-row class="form-group">
        <b-col cols="6">
          <label for="checkbox-group-1">{{ $t('common.global.client') }}</label>
          <b-form-checkbox-group
            id="checkbox-group-1"
            :disabled="readonly"
            v-model="selectedVerif"
            :options="listVerifClientSSL"
            stacked>
          </b-form-checkbox-group>
        </b-col>
        <b-col cols="6">
          <label for="checkbox-group-2">{{ $t('common.global.server') }}</label>
          <b-form-checkbox-group
            id="checkbox-group-2"
            :disabled="readonly"
            v-model="selectedVerif"
            :options="listVerifServerSSL"
            stacked>
          </b-form-checkbox-group>
        </b-col>
      </b-row>
    </form-accordion>
    <form-accordion :title="$t('common.global.encryption_and_signature')" :isTitleUpperCase="false">
      <b-row class="form-group">
        <b-col sm="6" class="form-group">
          <label for="encryption">
            {{ $t('common.global.encryption') }}
          </label>
          <select class="form-control" disabled id="encryption">
            <option>{{ $t('common.global.no') }}</option>
          </select>
        </b-col>
        <b-col sm="6" class="form-group">
          <label for="signature">
            {{ $t('common.global.signature') }}
          </label>
          <select class="form-control" disabled id="signature">
            <option>{{ $t('common.global.no') }}</option>
          </select>
        </b-col>
      </b-row>
    </form-accordion>
  </div>
</template>
<script>
import FormAccordion from '@/components/common/FormAccordion.vue'

export default {
  name: 'LevelControlForm',
  components: {
    'form-accordion': FormAccordion
  },
  props: {
    placementLevel: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
    }
  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    selectedVerif:{
      get () {
        return this.inputValue.selectedVerif
      },
      set (val) {
        this.inputValue = {
          selectedVerif: val,
        }
      }
    },
    pageTitle () {
      return this.$i18n.t('common.global.ctrl_level') + (this.placementLevel + 1 > 0 ? (' ' + (this.placementLevel)) : '')
    },
  },
  data () {
    return {
      listVerifClientSSL: [],
      listVerifServerSSL: [],
      verifChecked: ''
    }
  },
  created () {
    this.formType = this.mode
    this.listVerifClientSSL = [
      {
        id: 1,
        text: this.$i18n.t('common.global.verify_peer'),
        value: '1', disabled: true
      },
      {
        id: 2,
        text: this.$i18n.t('common.global.ctrl_CRL'),
        value: '2', disabled: true
      },
      {
        id: 3,
        text: this.$i18n.t('common.global.ctrl_key_usage'),
        value: '3', disabled: true
      },
      {
        id: 4,
        text: this.$i18n.t('common.global.ctrl_key_size'),
        value: '4', disabled: true
      },
      {
        id: 5,
        text: this.$i18n.t('common.global.ctrl_expiration'),
        value: '5', disabled: true
      },
      {
        id: 6,
        text: this.$i18n.t('common.global.ctrl_CN'),
        value: '6', disabled: true
      },
    ]
    this.listVerifServerSSL = [
      {
        id: 1,
        text: this.$i18n.t('common.global.ctrl_CA'),
        value: '7', disabled: true
      },
      {
        id: 2,
        text: this.$i18n.t('common.global.ctrl_CRL'),
        value: '8', disabled: true
      },
      {
        id: 3,
        text: this.$i18n.t('common.global.ctrl_key_usage'),
        value: '9', disabled: true
      },
      {
        id: 4,
        text: this.$i18n.t('common.global.ctrl_key_size'),
        value: '10', disabled: true
      },
      {
        id: 5,
        text: this.$i18n.t('common.global.ctrl_expiration'),
        value: '11', disabled: true
      },
      {
        id: 6,
        text: this.$i18n.t('common.global.ctrl_CN'),
        value: '12', disabled: true
      }
    ]
    this.selectedVerif = this.checkActivatedOptions(this.value)
  },
  methods: {
    checkActivatedOptions(modeSecurity) {
      let dictionnary = {
        listVerifClientSSL: {
          1: {id: 1, text: 'verify_peer', value: 1},
          2: {id: 2, text: 'ctrl_CRL', value: 32},
          3: {id: 3, text: 'ctrl_key_usage', value: 8},
          4: {id: 4, text: 'ctrl_key_size', value: 16},
          5: {id: 5, text: 'ctrl_expiration', value: 1024},
          6: {id: 6, text: 'ctrl_CN', value: 2048}
        },
        listVerifServerSSL: {
          7: {id: 7, text: 'ctrl_CA', value: 2},
          8: {id: 8, text: 'ctrl_CRL', value: 256},
          9: {id: 9, text: 'ctrl_key_usage', value: 64},
          10: {id: 10, text: 'ctrl_key_size', value: 128},
          11: {id: 11, text: 'ctrl_expiration', value: 512},
          12: {id: 12, text: 'ctrl_CN', value: 4096}
        }
      };

      let results = [];

      // Vérifier pour listVerifClientSSL
      Object.values(dictionnary.listVerifClientSSL).forEach(item => {
        if ((modeSecurity & item.value) === item.value) {
          results.push(item.id);
        }
      })
      // Vérifier pour listVerifServerSSL
      Object.values(dictionnary.listVerifServerSSL).forEach(item => {
        if ((modeSecurity & item.value) === item.value) {
          results.push(item.id)
        }
      })

      return results;
    }
  },
  watch: {
  }
}
</script>